<template>
    <AtomicButton
        v-tooltip="{
            content: locked ? lockMessage : '',
            placement: 'top',
            delay: {
                show: 150,
                hide: 150,
            },
            theme: 'info-tooltip',
        }"
        :data-helper-tooltip="name"
        :disabled="disabled || locked"
        :size="size"
        :color="color"
        :rounded="rounded"
        :type="type"
    >
        <template #icon>
            <LockClosedIcon v-if="locked" class="mr-2 h-4 w-4" />

            <template v-else>
                <slot name="icon" />
            </template>
        </template>
        <slot />
    </AtomicButton>
</template>
<script lang="ts" setup>
import { LockClosedIcon } from '@heroicons/vue/24/solid';
import { useId } from 'vue';

defineProps({
    /**
     * Is button disabled
     * @values true, false
     */
    disabled: {
        type: Boolean,
        default: false,
    },

    /**
     * The size of the button
     * @values sm, md, lg, xs
     */
    size: {
        type: String,
        default: 'md',
    },

    /**
     * The color of the button
     * @values yellow, red, purple, white, transparent
     */
    color: {
        type: String,
        default: 'yellow',
    },

    /**
     * The border radius of the button
     * @values md, lg, xl
     */
    rounded: {
        type: String,
        default: 'md',
    },

    type: {
        type: String as () => 'button' | 'submit' | 'reset' | undefined,
        validator(value: string | undefined) {
            return (
                value === undefined ||
                ['button', 'submit', 'reset'].includes(value)
            );
        },
        default: 'button',
    },

    locked: {
        type: Boolean,
        default: false,
    },
    lockMessage: {
        type: String,
        default: '',
    },
});

const name = useId();
</script>
